import { CreateVersionType } from '@/types';
import { axiosDelete, axiosPost } from '../AxiosApi';
import { sendRequest } from '../AxiosRequest';

export const createVersion = async (createVersion: CreateVersionType) => {
  const payload = {
    path: '/version/create',
    body: { ...createVersion },
  };
  return await sendRequest(payload, 'createVersion', axiosPost);
};

export const deleteVersion = async (versionId: string) => {
  const payload = {
    path: '/version',
    body: { versionId },
  };
  return await sendRequest(payload, 'deleteVersion', axiosDelete);
};
